import { render, staticRenderFns } from "./TreeWrapper.vue?vue&type=template&id=104761de"
import script from "./TreeWrapper.vue?vue&type=script&lang=js"
export * from "./TreeWrapper.vue?vue&type=script&lang=js"
import style0 from "./TreeWrapper.vue?vue&type=style&index=0&id=104761de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports